import { isDefined } from "@clipboard-health/util-ts";
import { isBefore } from "date-fns";

import { type NotificationData } from "../types";

/**
 * Check whether a notification has expired based on its TTL.
 *
 * Returns `true` if both `ttlSeconds` and `createdTimeUTC` are present
 * and the notification's expiry time (created + TTL) is before now.
 * Returns `false` if either field is missing or not parseable — treating
 * notifications without TTL as always valid.
 */
export function isNotificationExpired(data: NotificationData): boolean {
  const { ttlSeconds, createdTimeUTC } = data;
  if (!isDefined(ttlSeconds) || !isDefined(createdTimeUTC)) {
    return false;
  }

  const ttl = Number(ttlSeconds);
  if (Number.isNaN(ttl) || ttl <= 0) {
    return false;
  }

  const createdAt = new Date(createdTimeUTC);
  if (Number.isNaN(createdAt.getTime())) {
    return false;
  }

  const expiresAt = new Date(createdAt.getTime() + ttl * 1000);
  return isBefore(expiresAt, new Date());
}
